import React from 'react';
import {Button} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ChatIcon from '@mui/icons-material/Chat';
import {ButtonRow, CardHeader, CardWrapper, Description, StatusIndicator, Title,} from './styles';
import {useDashboardContext} from "../../../Dashboard";

export default function SupportCard() {
    const {SUPPORT_DATA, settings: {firm}} = useDashboardContext();

    return (
        <CardWrapper>
            <CardHeader>
                <SupportAgentIcon color="primary"/>
                <Title>{SUPPORT_DATA.title}</Title>
            </CardHeader>
            <Description>{SUPPORT_DATA.subtitle}</Description>
            <StatusIndicator>
                <span/>
                {SUPPORT_DATA.onlineStatus}
            </StatusIndicator>
            <ButtonRow>
                <Button target={"_blank"} href={firm.telegramSupport} variant="contained" color="primary"
                        startIcon={<ChatIcon/>}
                        style={{textTransform: 'none', borderRadius: 8, backgroundColor: '#d81b60'}}>
                    {SUPPORT_DATA.buttonChat}
                </Button>
            </ButtonRow>
        </CardWrapper>
    );
}
